import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Typography, withStyles } from "@material-ui/core";
import XAPPTooltip from "app/Core/Components/Tooltip/XAPPTooltip";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import classNames from "classnames";
import React from "react";
import { ImFileEmpty, ImFilePdf, ImFilePicture, ImFileText2 } from "react-icons/im";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/ArquivoActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    },
    arquivoItem: {
        transitionProperty: "box-shadow",
        transitionDuration: theme.transitions.duration.short,
        transitionTimingFunction: theme.transitions.easing.easeInOut,
        "&:hover": {
            boxShadow: theme.shadows[5]
        },
    },
    textColor: {
        color: theme.palette.type === "dark" ? "#FFFFFF" : "#000000"
    }
});

class ArquivoList extends XAPPComponent {

    state = {
        selected: [],
    };

    componentDidUpdate() {
        if (this.props.Arquivo.error) {
            this.props.showMessage({
                message: this.props.Arquivo.error,
                variant: "error"
            });
            this.props.Arquivo.error = null;
        }
        if (this.props.Arquivo.warning) {
            this.props.showMessage({
                message: this.props.Arquivo.warning,
                variant: "warning"
            });
            this.props.Arquivo.warning = null;
        }
        if (this.props.Arquivo.info) {
            this.props.showMessage({
                message: this.props.Arquivo.info,
                variant: "success"
            });
            this.props.Arquivo.info = null;
        }
    }

    getArquivoFilter = () => {
        var array = [];
        const { arquivoState, Arquivo, conditions = null } = this.props;
        if (!_.isUndefined(Arquivo.data) && !_.isNull(Arquivo.data)) {
            Arquivo.data.forEach(item => {
                var BTagSel = false;
                var BFilterSel = false;

                if (item.pasta === arquivoState.pasta) {
                    BTagSel = true;
                    BFilterSel = true;

                    if (!_.isNull(conditions)) {
                        const { tag, filter } = conditions;
                        if (!_.isUndefined(tag) && !_.isNull(tag) && tag.length > 0) {
                            BTagSel = false;
                            tag.split(",").forEach((itemtag) => {
                                if (item.tags !== null && item.tags.split(",").includes(itemtag)) {
                                    BTagSel = true;
                                }
                                else {
                                    BTagSel = false;
                                }
                            });
                        }

                        if (BTagSel && !_.isUndefined(filter) && !_.isNull(filter) && filter.length > 0) {
                            BFilterSel = false;
                            if (filter.includes(item.mimetype) || item.mimetype.includes(filter)) {
                                BFilterSel = true;
                            }
                        }
                    }

                    if (BTagSel && BFilterSel) {
                        array.push(item);
                    }
                }
            });
        }
        return array;
    };

    getIconFile = (_AType) => {
        switch (_AType) {
            case "application/pdf": return <ImFilePdf className={classNames("text-56")} />;
            case "text/plain": return <ImFileText2 className={classNames("text-56")} />;
            case "image/jpg": return <ImFilePicture className={classNames("text-56")} />;
            default: return <ImFileEmpty className={classNames("text-56")} />;
        }
    };

    render() {
        const { xappRouteParams, classes, get } = this.props;
        const data = this.getArquivoFilter();
        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <div className="flex justify-start flex-wrap">
                    {data.length > 0 ?
                        <React.Fragment>
                            {data.map(arquivo => (
                                <XAPPTooltip
                                    key={arquivo.idarquivo}
                                    placement="top"
                                    title={
                                        <React.Fragment>
                                            {arquivo.nome} <br /> {arquivo.descricao} <br />
                                        </React.Fragment>
                                    }
                                >
                                    <div
                                        className={
                                            classNames(
                                                classes.arquivoItem,
                                                "items-center justify-center relative w-96 h-72 rounded-4 ml-8 mb-8 overflow-hidden cursor-pointer")
                                        }
                                        key={arquivo.idarquivo}
                                        onClick={() => get("SELECIONAR", xappRouteParams, arquivo.idarquivo)}
                                    >
                                        <React.Fragment>
                                            <div className="flex flex-col items-center">
                                                {this.getIconFile(arquivo.mimetype)}
                                            </div>
                                            <Typography className="text-center text-11">
                                                {arquivo.nome.length > 10 ? arquivo.nome.substr(0, 10) + " ..." : arquivo.nome}
                                            </Typography>
                                        </React.Fragment>
                                    </div>
                                </XAPPTooltip>
                            ))}
                        </React.Fragment>
                        :
                        <div className="flex flex-col flex-1 items-center justify-center p-48">
                            <div className="max-w-512 text-center">
                                <FuseAnimate delay={500}>
                                    <Typography variant="h6" color="textSecondary" className="mb-16">
                                        {"Não existem registros cadastrados!"}
                                    </Typography>
                                </FuseAnimate>
                            </div>
                        </div>
                    }
                </div>
            </FuseAnimate>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        get: Actions.get,
        remove: Actions.remove,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ Arquivo }) {
    return {
        Arquivo: Arquivo
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ArquivoList)));
